import { useEffect, useRef } from 'react';

const useScript = (url: string, type?: string, onError?: (event: ErrorEvent) => void) => {
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    if (type) {
      script.type = type;
    }
    script.onerror = (event) => onErrorRef.current?.(event as ErrorEvent);
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
    // type is intentionally omitted — changing it should not reload the script
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
};

export default useScript;
